import { toError } from './parsers/error';
import { createSource } from '../sources/Source';
import { PrivateSite } from '../sources/private-site/PrivateSite';
import { Private } from '../sources/private/Private';
import { Public } from '../sources/public/Public';

/**
 * Load files metadata
 * @param ids
 * @param options
 * @param options.publicSettings
 * @param options.privateSettings
 * @returns {Promise<T>}
 */
export function fetchFilesMetadata(ids, _temp) {
  let {
    publicSettings = {},
    privateSettings = {}
  } = _temp === void 0 ? {} : _temp;
  const sourcePublic = createSource(Public, publicSettings);
  const promiseList = [sourcePublic.item.get(ids)];
  if (privateSettings.siteMediaToken) {
    const sourcePrivate = createSource(PrivateSite, privateSettings);
    promiseList.push(sourcePrivate.items.get(ids));
  } else {
    const sourcePrivate = createSource(Private, privateSettings);
    promiseList.push(sourcePrivate.item.get(ids[0]).then(response => {
      response.data = [response.data];
      return response;
    }, () => {
      return {
        data: []
      };
    }));
  }
  return Promise.all(promiseList).then(responses => Array.prototype.concat.apply([], responses.map(response => response.data))).catch(toError);
}